
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.5 5C12.835 5 5 12.835 5 22.5c0 7.414 4.613 13.746 11.122 16.296-.153-1.385-.29-3.508.061-5.02.318-1.366 2.052-8.699 2.052-8.699s-.523-1.048-.523-2.598c0-2.433 1.41-4.25 3.166-4.25 1.493 0 2.215 1.121 2.215 2.465 0 1.502-.956 3.747-1.45 5.827-.412 1.742.874 3.162 2.592 3.162 3.11 0 5.5-3.28 5.5-8.013 0-4.19-3.01-7.12-7.309-7.12-4.98 0-7.902 3.735-7.902 7.594 0 1.504.58 3.117 1.302 3.994a.523.523 0 01.122.502c-.133.553-.428 1.741-.486 1.985-.077.32-.254.388-.586.234-2.185-1.018-3.552-4.213-3.552-6.78 0-5.52 4.011-10.59 11.563-10.59 6.07 0 10.789 4.326 10.789 10.107 0 6.031-3.803 10.885-9.081 10.885-1.774 0-3.44-.921-4.011-2.01 0 0-.878 3.342-1.09 4.16-.396 1.52-1.462 3.426-2.176 4.589 1.638.507 3.378.78 5.182.78C32.165 40 40 32.165 40 22.5S32.165 5 22.5 5"}})])
          )
        }
      }
    